export default __webpack_public_path__ + "static/media/twitter.7a8d6d16.svg";